import React from "react";
import styled from "styled-components";

const SendMessageLoader = () => {

    return (
        <Div><p>Envoi...</p></Div>
    )
}

const Div = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items:center;
  p {
    overflow: hidden; /* Ensures the content is not revealed until the animation */
    -webkit-animation: typing 3.5s infinite steps(30, end);
    animation: typing 1.5s  infinite steps(30, end);
  }

  /* The typing effect */
  @keyframes typing {
    from {
      width: 0;
    }
    to {
      width: 100%;
    }
  }

`

export default SendMessageLoader